
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 244"}},[_c('g',{attrs:{"data-name":"Group 243"}},[_c('path',{attrs:{"data-name":"Path 104","d":"M0 34.4v931.2h1000V34.4zm880.57 271.3h-320.4V153.53H880.7zm0 540.47h-320.4V694H880.7zm-440.44 0h-320.7V694h320.7zm-320.7-422.24h320.7v1.2h.57v149.44h-.6v1.53H119.4zm0-270.4h320.7V305.7h-320.7zM880.7 576.1H560.3v-1.53h-.9V425.13h.9v-1.2h320.4z","fill":"#0f59ec"}})])])])
          )
        }
      }
    